import React, { useState } from "react"
import {
  Modal,
  Box,
  Typography,
  Fade,
  Backdrop,
  Divider,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material"

const AddToPipelineModal = ({
  title = "GenAI Mapping",
  isOpen,
  onClick,
}: any) => {
  const [saveToBlobStorage, setSaveToBlobStorage] = useState(false)
  const [deployToADF, setDeployToADF] = useState(false)

  const handleButtonClick = (action?: string) => () => onClick(action)

  const modalStyle = {
    display: "flex",
    flexDirection: "column",
    width: 562,
    height: 220,
    bgcolor: "background.paper",
    boxShadow: 24,
    px: 3,
    py: 2.5,
    borderRadius: 3,
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  }

  const buttonStyle = {
    textTransform: "none",
    fontSize: "11px",
    fontWeight: 600,
    flex: 1,
  }

  const handleSaveToBlobStorageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSaveToBlobStorage(event.target.checked)
  }

  const handleDeployToADFChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDeployToADF(event.target.checked)
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleButtonClick("cancel")}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Fade in={isOpen}>
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              flexGrow: 1,
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">{title}</Typography>
            <Divider />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              mt: 0.5,
              gap: 2,
            }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={saveToBlobStorage}
                    onChange={handleSaveToBlobStorageChange}
                    color="primary"
                  />
                }
                label="Save Mapping File to Blob Storage"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={deployToADF}
                    onChange={handleDeployToADFChange}
                    color="primary"
                  />
                }
                label="Deploy Mapping File to Azure Data Factory"
              />
            </FormGroup>

            <Box display="flex" gap={1.25} px={2}>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  ...buttonStyle,
                  color: "#000",
                }}
                onClick={handleButtonClick("cancel")}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  ...buttonStyle,
                  color: "#fff",
                  boxShadow: 0,
                }}
                onClick={handleButtonClick("continue")}
              >
                Continue
              </Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  )
}

export default AddToPipelineModal
